import Typography from "@mui/material/Typography";

type MessageNoteProps = {
  text: string;
  ai?: boolean;
};

export const MessageNote = ({ text, ai = false }: MessageNoteProps) => {
  const bgcolor = ai ? "info.main" : "primary.main";
  const textColor = ai ? "primary.main" : "primary.contrastText";
  return (
    <Typography
      variant="caption"
      sx={{
        bgcolor: bgcolor,
        borderRadius: "10px",
        padding: "2px 6px",
        fontSize: "0.7rem",
        border: `1px solid`,
        color: textColor,
      }}
    >
      {text}
    </Typography>
  );
};
